import { Box } from "@raca2022/uikit";
import styled from "styled-components";

export const Container = styled(Box)`
  padding: 3.75vw 11.97vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    h1 {
      font-weight: 700;
      font-size: 2.6vw;
      line-height: 110%;
      color: #20665e;
      font-family: "PoppinsBold";
      margin-bottom: 2.6vw;
    }
    p {
      font-weight: 500;
      font-size: 1.25vw;
      line-height: 110%;
      color: #8094ae;
      font-family: "PoppinsMedium";
      margin-bottom: 1.25vw;
    }
    button {
      margin-top: 2vw;
      width: 13.48vw;
      height: 2.9vw;
      background: #009768;
      box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
      border-radius: 10px;
      font-weight: 600;
      font-size: 0.9375vw;
      line-height: 110%;
      font-family: "PoppinsSemiBold";
      color: #ffffff;
    }
  }
  img {
    width: 37.23vw;
    max-width: 715px;
  }
  @media only screen and (min-width: 1920px) {
    padding: 72px 230px;
    div {
      h1 {
        font-size: 50px;
        margin-bottom: 52px;
      }
      p {
        font-size: 24px;
        margin-bottom: 24px;
      }
      button {
        margin-top: 40px;
        width: 259px;
        height: 56px;
        font-size: 18px;
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    padding: 7.9vw 3.27vw;
    flex-direction: column;
    align-items: center;
    div {
      h1 {
        font-size: 4.2vw;
        margin-bottom: 4.2vw;
        text-align: center;
      }
      p {
        text-align: center;
        font-size: 2.8vw;
        margin-bottom: 2.8vw;
      }
      button {
        display: none;
      }
    }
    img {
        width: 100%;
        max-width: 715px;
      }
  }
`;
